




import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Formik, Form } from 'formik';

import { FaPlus } from "react-icons/fa6";
import { MdPayment } from 'react-icons/md';

import CustomInputLogin from '../../../../../Components/CustomInputLogin/CustomInputLogin';
import '../BannerinputGetModal.css'; // Import external CSS
import { MdCancel } from "react-icons/md";
import * as Yup from 'yup';
import { FiUpload } from 'react-icons/fi';
import FileUploadComponent from '../../../../../Components/FileUploadComponent/FileUploadComponent';
import ActiveInactiveRadio from '../../../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import { clearCustomerId } from '../../../../../ReduxStore/Slices/Operator/customerSlice';
import { clearTableGetId } from '../../../../../ReduxStore/Slices/TableId/TableIdGetSlice';
import PreviewComponent from '../../../PreviewComponent/PreviewComponent';
import AppLink from '../../AppLink/AppLink';
import DownloadPhone from '../../AppLink/AppLink/DownloadPhone';


const AppLinkHeadingModal = ({ open, onClose, setSubmittedValues, submittedValues }) => {
    const [uploadedFile, setUploadedFile] = useState(null);


    const role = sessionStorage.getItem('role')

    //   useEffect(() => {
    //     if (!open) return;
    //     const fetchData = async () => {
    //       const data1 = { data: {}, method: "get", apiName: `getAllRoles` };
    //       await dispatch(actions.GETALLROLES(data1));
    //     };
    //     fetchData();
    //   }, [dispatch, createRoleWithPermissions]);

    const dispatch = useDispatch()

    const { addHomeSectionPost } = useSelector(
        (state) => state?.addHomeSectionPost
    );


    const { addHomeSectionWithApproval } = useSelector(
        (state) => state?.addHomeSectionWithApproval
    );


    const { addStakeNowSectionPost } = useSelector(
        (state) => state?.addStakeNowSectionPost
    );

    const { updateHomeSection } = useSelector(
        (state) => state?.updateHomeSection
    );

    const { updateHomeSectionForReApproval } = useSelector(
        (state) => state?.updateHomeSectionForReApproval
    );


    const [loading, setLoading] = useState(false);




    const [editResponseData, setEditResponseData] = useState()
    const TableId = useSelector((state) => state.Table.TableId);


    console.log(editResponseData, "editResponseDataeditResponseDataeditResponseData")
    console.log(TableId, "TebleIddddd")

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getHomeSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETHOMESECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Home section retrieved successfully.") {
                    console.log("hiiii")

                    setEditResponseData(response?.payload?.data)
                    setUploadedFile({
                        fileUrl: response?.payload?.data.additional_data[0]?.banner,
                        type: "img",
                        progress: 100,
                    }
                    )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, [open]);




    const handleSubmit = async (values, resetForm) => {
        setLoading(true)

        if (!TableId) {

            if (role === "superAdmin") {

                const data1 = {
                    data: {
                        section_name: "applink",//pass from parent component
                        heading: values?.title,
                        // sub_heading: values?.sub_text,

                        content: values?.content,
                        additional_data: [
                            {
                                banner: values?.image,

                                play_store_link: values?.play_store_link,
                                app_store_link: values?.app_store_link,

                            }
                        ]
                    },
                    method: "Post",
                    apiName: `addHomeSectionWithApproval`
                };
                const responseData = await dispatch(actions.ADDHOMESECTIONWITHAPPROVAL(data1));

                if (responseData?.payload?.message === "Home section added and approved successfully. Previous approved section deactivated.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)

                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("App Link section added successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            } else {
                const data1 = {
                    data: {
                        section_name: "applink",//pass from parent component
                        heading: values?.title,
                        // sub_heading: values?.sub_text,

                        content: values?.content,
                        additional_data: [
                            {
                                banner: values?.image,

                                play_store_link: values?.play_store_link,
                                app_store_link: values?.app_store_link,

                            }
                        ]
                    },
                    method: "Post",
                    apiName: `addHomeSection`
                };
                const responseData = await dispatch(actions.ADDHOMESECTIONPOST(data1));
                if (responseData?.payload?.message === "Home section added successfully.") {
                    // handlePreviewCloseModal()
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("App Link section added successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            }
        } else {

            if (role === "superAdmin") {

                const data1 = {
                    data: {
                        section_name: "applink",//pass from parent component
                        heading: values?.title,
                        // sub_heading: values?.sub_text,

                        content: values?.content,
                        additional_data: [
                            {
                                banner: values?.image,
                                // primary_button_text: values.primary_button_text,

                                play_store_link: values?.play_store_link,
                                app_store_link: values?.app_store_link,


                            }
                        ]
                    },
                    method: "put",
                    apiName: `updateHomeSection/${TableId}`
                };
                const responseData = await dispatch(actions.UPDATEHOMESECTION(data1));

                if (responseData?.payload?.message === "App Link updated successfully.") {
                    // handlePreviewCloseModal()

                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("App Link section update successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()
                    //     dispatch(clearCustomerId(null))
                    //     dispatch(clearTableGetId(null))

                    //     setUploadedFile(null)

                    // }, 2500)
                }
                else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            } else {
                const data1 = {
                    data: {
                        section_name: "applink",//pass from parent component
                        heading: values?.title,
                        sub_heading: values?.sub_text,
                        content: values?.content,
                        additional_data: [
                            {
                                banner: values.image,

                                play_store_link: values?.play_store_link,
                                app_store_link: values?.app_store_link,

                            }
                        ]
                    },
                    method: "put",
                    apiName: `updateHomeSectionForReApproval/${TableId}`
                };
                const responseData = await dispatch(actions.UPDATEHOMESECTIONFORREAPPROVAL(data1));
                if (responseData?.payload?.message === "Home section updated and sent for re-approval.") {
                    // handlePreviewCloseModal()
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.success("App Link section update successfully!!")


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            }

        }
    }

    const [isPreviewModalOpen, setPreviewModalOpen] = useState(false)

    const handlePreviewOpenModal = () => {
        setPreviewModalOpen(true);
    };

    const handlePreviewCloseModal = () => {
        setPreviewModalOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                // maxWidth: "600px",
                // margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        // onClick={onClose}
                        onClick={() => {
                            onClose()
                            dispatch(clearCustomerId(null))
                            dispatch(clearTableGetId(null))
                        }}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">

                        <Box>
                            <Typography className="custom-title-text" fontSize="16px" color="white">
                                App Link Modal
                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>

                <Formik


                    enableReinitialize
                    initialValues={{


                        title: editResponseData?.heading || '',
                        content: editResponseData?.content || '',
                        // sub_text: editResponseData?.sub_heading || '',


                        play_store_link: editResponseData?.additional_data[0]?.play_store_link || '',
                        app_store_link: editResponseData?.additional_data[0]?.app_store_link || '',

                        // image:null
                        image: editResponseData?.additional_data?.[0]?.banner || null,

                        // initialValues={{
                        //     title: '',
                        //     status: "active",
                        //     url: "",
                        //     play_store_link: "",
                        //     app_store_link: "",
                        //     // sub_text: "",
                        //     content: '',
                        //     image: null,
                    }}
                    validationSchema={Yup.object({
                        title: Yup.string().required('Title is required'),
                        play_store_link: Yup.string().required('PlayStore Link is required'),
                        app_store_link: Yup.string().required('AppStore Link is required'),
                        // sub_text: Yup.string().required('Sub Text is required'),
                        // status: Yup.string().required('Status is required'),
                        content: Yup.string().required('Content is required'),
                    })}
                    onSubmit={(values, { resetForm }) => {
                        // setSubmittedValues([...submittedValues, values]);
                        // console.log(values, "values")
                        console.log("Form values:", values);

                        isPreviewModalOpen ? handleSubmit(values, resetForm) : handlePreviewOpenModal()

                    }}
                >
                    {({ handleSubmit, setFieldValue, resetForm, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    {/* Title and Subtitle on the left, Content on the right */}
                                    <Grid item xs={12} md={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <CustomInputLogin
                                                    label="Title"
                                                    name="title"
                                                    inputType="text"
                                                    custPlaceholder="Enter Title"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CustomInputLogin
                                                    label="PlayStore Link"
                                                    name="play_store_link"
                                                    inputType="text"
                                                    custPlaceholder="Enter Button Text"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CustomInputLogin
                                                    label="AppStore Link"
                                                    name="app_store_link"
                                                    inputType="text"
                                                    custPlaceholder="Enter URL"
                                                />
                                            </Grid>


                                            <Grid item xs={12} md={8}>
                                                <CustomInputLogin
                                                    label="Content"
                                                    name="content"
                                                    inputType="textarea"
                                                    custPlaceholder="Enter Content"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <FileUploadComponent name="image" uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} onFileUpload={(file) => setFieldValue('image', file)} />

                                            </Grid>


                                        </Grid>


                                    </Grid>

                                </Grid>

                                {/* Action Buttons */}
                                {/* <DialogActions> */}
                                <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
                                    <Grid>
                                        <Button
                                            onClick={() => {
                                                resetForm()
                                                setUploadedFile(null)
                                                dispatch(clearCustomerId(null))
                                                dispatch(clearTableGetId(null))

                                            }}
                                            variant="text"
                                            // className="custom-clear-button"
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                mr: "10px",
                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                borderRadius: "23px",
                                                background: "white",
                                                boxShadow: "none",
                                                color: "black",
                                                border: "1px solid black",
                                                "&:hover": {
                                                    backgroundColor: "#3B4056",
                                                    color: "white"
                                                },
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            // onClick={handlePreviewOpenModal}

                                            variant="contained"
                                            // className="custom-ok-button"
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                boxShadow: "none",

                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                borderRadius: "23px",
                                                background: "#C38F51 0% 0% no-repeat padding-box",
                                                "&:hover": {
                                                    backgroundColor: "#3B4056",
                                                    boxShadow: "none",

                                                },
                                            }}
                                        >
                                            Preview
                                        </Button>
                                    </Grid>
                                </Grid>

                            </DialogContent>
                            <PreviewComponent
                                showSubmitButton={true}
                                open={isPreviewModalOpen}
                                ModalPreviewComponent={DownloadPhone}
                                onClose={handlePreviewCloseModal}
                                values={values}
                                resetForm={resetForm}
                                ParentModalClose={onClose}
                                handleSubmit={handleSubmit}
                                loading={loading}
                                setLoading={setLoading}
                            />
                            {/* </DialogActions> */}
                        </Form>
                    )}
                </Formik>

            </Box>
        </Dialog >
    );
};

export default AppLinkHeadingModal;
